import React, { useState, useEffect } from 'react';
import ChartAllocation from './ChartAllocation';
import { fetchData } from './FetchData';

function filterData(data) {
  return data.filter((d) => {
    return true;
  });
}

function prepareChartAllocationData(data) {
  // usually more wrangling is required but the example data is simple
  return data;
}

const useData = (dataSet) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchNewData = async () => {
      try {
        setLoading(true);
        setError(false);
        const data = await fetchData(dataSet);
        const dataClean = filterData(data);
        setData(prepareChartAllocationData(dataClean));
        setLoading(false);
      } catch (err) {
        console.log(err);
        setError(err);
        setLoading(false);
      }
    };
    fetchNewData();
  }, [dataSet]);

  return [data, loading, error];
};

const ChartAllocationData = ({ id }) => {
  const [dataSet, setDataSet] = useState('dataAllocation');
  const [data, loading, error] = useData(dataSet);

  return (
    <>
      <ChartAllocation data={data} error={error} id={id} loading={loading} />
    </>
  );
};

export default ChartAllocationData;
